import { connect } from 'react-redux';
import BaseCollection from './BaseCollection';
import { showSiteVarianceHistoryModal, showCollectionModal } from '../../redux/actions/modals'
import collections from '../../api/collections';

class CollectionBanking extends BaseCollection {

  fnRowClick = collections.getBankingWeekDetail;
  fnRefresh = collections.getBankingWeek;
  fnGetSummaryPdf = collections.getBankingSummaryPdf;
  fnGetVariancePdf = collections.getBankingVariancePdf;
  fnGetExport = collections.getBankingWeekExport;
  
  reportName = "Banking Report PDF";
  modalTitle = "Collection Week Banking";
  reportFileName = "Collection Week Banking";
  exportFileName = "Collection Week Banking Export CSV"
  handleVarianceHistory = () => this.props.showSiteVarianceHistoryModal(true);

}

const mapStateToProps = state => {
	return {
    installationsFilters: state.installationsFilters,
    collectionsFilters: state.collectionsFilters,
  };
};

export default connect(mapStateToProps, { showSiteVarianceHistoryModal, showCollectionModal })(CollectionBanking)


